import React, { useMemo } from "react";
import Joyride from "react-joyride";
import { useTheme } from "@mui/material";

/**
 * react-joyride + react-floater (Popper.js v1):
 * O padrão preventOverflow.boundariesElement = "scrollParent" prende o tooltip ao <main> com overflow,
 * cortando o balão e os botões. Forçamos window/viewport e damos rolagem só no texto do tooltip.
 */
const Tour = ({ steps, isTourActive, onTourEnd }) => {
  const theme = useTheme();

  const floaterProps = useMemo(
    () => ({
      options: {
        preventOverflow: {
          boundariesElement: "window",
          padding: 16,
        },
        flip: {
          enabled: true,
          boundariesElement: "viewport",
          padding: 16,
        },
      },
    }),
    []
  );

  const joyrideStyles = useMemo(
    () => ({
      options: {
        arrowColor: theme.palette.background.paper,
        backgroundColor: theme.palette.background.paper,
        overlayColor: "rgba(0, 0, 0, 0.5)",
        primaryColor: theme.palette.primary.main,
        textColor: theme.palette.text.primary,
        zIndex: 20000,
        width: 420,
      },
      tooltip: {
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[8],
        maxWidth: "min(440px, calc(100vw - 24px))",
      },
      tooltipContainer: {
        lineHeight: 1.5,
        textAlign: "left",
        maxHeight: "min(36vh, 300px)",
        overflowY: "auto",
        overflowX: "hidden",
        WebkitOverflowScrolling: "touch",
      },
      tooltipContent: {
        padding: "8px 2px 12px",
      },
      tooltipFooter: {
        flexShrink: 0,
        marginTop: 8,
        paddingTop: 8,
        borderTop: `1px solid ${theme.palette.divider}`,
      },
    }),
    [theme]
  );

  return (
    <Joyride
      steps={steps}
      continuous
      showProgress
      showSkipButton
      scrollToFirstStep
      scrollOffset={80}
      floaterProps={floaterProps}
      locale={{
        back: "Voltar",
        close: "Fechar",
        last: "Finalizar",
        next: "Próximo",
        nextLabelWithProgress: "Próximo (Passo {step} de {steps})",
        open: "Abrir",
        skip: "Pular",
      }}
      styles={joyrideStyles}
      run={isTourActive}
      callback={(data) => {
        if (data.status === "finished" || data.status === "skipped") {
          onTourEnd();
        }
      }}
    />
  );
};

export default Tour;
